<template>
  <div  class="delete-container">
  <div class="delete-content">
    <i class="el-icon-close close-icon" @click="cancleDelete"></i>
    <!-- <div class="delete-title">
      <i class="el-icon-warning"></i>
      提示
    </div> -->
    <el-form class="form-container">
      <el-form-item class="input-list" label="付费" prop="payment">
        <el-radio-group class="radio-content" @change="radioChange" v-model="update_detail.payment">
          <el-radio class="radio-list" :label="0">未付费</el-radio>
          <el-radio class="radio-list" :label="1">已付费</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item class="input-list" label="发票" prop="receipt_status">
        <el-radio-group class="radio-content" @change="receiptChange" v-model="update_detail.receipt_status">
          <el-radio class="radio-list" :label="0">未开票</el-radio>
          <el-radio class="radio-list" :label="3">普票</el-radio>
          <el-radio class="radio-list" :label="4">增值票</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item class="input-list" label="发票号" prop="receipt_no">
        <el-input type="text" placeholder="请输入发票" v-model="update_detail.receipt_no"></el-input>
      </el-form-item>
      <el-form-item class="input-list" label="备注" prop="memo">
        <el-input type="textarea" placeholder="请输入备注" v-model="update_detail.memo"></el-input>
      </el-form-item>
      <div class="btn-container">
        <el-button class="btn-list cancle-btn" @click="cancleDelete">取消</el-button>
        <el-button class="btn-list sure-btn" @click="sureDelete">确认</el-button>
      </div>
    </el-form>
  </div>
</div>
</template>

<script type="text/javascript">
export default {
  props: ['update'],
  data() {
    return {
      update_detail: {...this.update}
    }
  },
  methods: {
    radioChange(e) {
      this.update_detail.payment = e
    },
    receiptChange(e) {
      this.update_detail.receipt_status = e
    },
    cancleDelete () { // 取消删除
      this.$emit('delete', 'cancle')
      this.$message({
        type: 'info',
        message: '取消删除此数据！',
        customClass: 'msg-position',
        showClose: true
      })
    },
    sureDelete () { // 确认删除
      this.$emit('sure', {...this.update_detail})
    }
  }
}
</script>

<style lang='stylus' rel='stylesheet/stylus'>
@import '~common/stylus/mixin.styl'
.delete-container
  position:fixed;
  left:0;
  right:0;
  top:0;
  bottom:0;
  background-color:rgba(0, 0, 0, 0.2);
  z-index:10;
  display: flex;
  justify-content: center;
  align-items: center;
  .delete-content
    background:#fff;
    z-index: 100;
    padding: 2rem 1rem;
    border-radius: 0.4rem;
    position: relative;
    width:22rem;
    .delete-title
      text-align:center;
      font-size:0.8rem;
      .el-icon-warning
        color:red;
        font-size:1rem;
    .form-container
      padding: 2rem;
      .input-list
        display: flex;
        margin-bottom: 0.5rem;
        height:2rem;
        &.is-error
        .el-form-item__content
          .el-input
            .el-input__inner
              border: 0.05rem solid #EF757A;
          .el-textarea
            .el-textarea__inner
              border: 0.05rem solid #EF757A;
        .el-form-item__label
          color:#474747;
          font-size:0.7rem
          flex: 0 0 4rem;
          text-align: left;
        .el-form-item__content
          position:relative;
          flex: 1;
          .el-input
            height:2rem;
            .el-input__inner
              padding: 0 0.8rem;
          .el-form-item__error
            /* top:0.5rem; */
            left: 0.8rem;
            background:#fff;
            color:#EF757A;
      .radio-content
        height:2rem;
        margin-bottom: 1rem;
        display: flex;
        align-items: center;
        .radio-list
          color: #666;
          font-size: 0.7rem;
          .el-radio__label
            color:#666;
          &.is-checked
            .el-radio__label
              color:#666;
          .el-radio__input
            .el-radio__inner
              border:0;
              width: 1rem;
              height:1rem;
              background-color:#fff;
              bg-image('~assets/radio.png');
          &.is-checked
            .el-radio__inner
              bg-image('~assets/radio_checked.png');
    .btn-container
      margin-top:1.5rem;
      padding: 0rem;
      width:100%;
      color: #666;
      box-sizing:border-box;
      display: flex;
      .btn-list
        flex:1;
        color:#fff;
        border:0;
        &.cancle-btn
          background: #cfcfcf;
          color:#fff;
          span
            color:#fff;
        &.sure-btn
          background: #EF757A;
          span
            color:#fff;
    .close-icon
      position: absolute;
      top:0.5rem;
      right:0.5rem;
      color:#9a9a9a;
      font-size:1.2rem;
</style>
